module.exports = __webpack_public_path__ + "img/07李汉尊.d9f88fdc.jpg";